import React from "react";
import { Flex } from "@chakra-ui/react";
import { CalendarItemState } from "../utils";

export interface Props {
	label: string;
	value?: Date | null;
	state?: CalendarItemState;
	onClick?: (date: Date) => void;
	isSelectable?: boolean;
	weekdayIndicator?: boolean;
}

export function CalendarItem({
	label = "",
	value = null,
	state = CalendarItemState.Default,
	onClick = () => {},
	isSelectable = false,
	weekdayIndicator = false,
}: Props): JSX.Element {
	const backgroundColors = {
		[CalendarItemState.Today]: "brand.200",
		[CalendarItemState.Default]: "neutrals.0",
		[CalendarItemState.OutOfRange]: "neutrals.0",
		[CalendarItemState.Selected]: "brand.400",
	};

	const borderColors = {
		[CalendarItemState.Today]: "brand.300",
		[CalendarItemState.Default]: "neutrals.0",
		[CalendarItemState.OutOfRange]: "neutrals.0",
		[CalendarItemState.Selected]: "brand.400",
	};

	const borderRadius = {
		[CalendarItemState.Today]: "md",
		[CalendarItemState.Default]: "0",
		[CalendarItemState.OutOfRange]: "0",
		[CalendarItemState.Selected]: "md",
	};

	const fontColor = {
		[CalendarItemState.Today]: "neutrals.800",
		[CalendarItemState.Default]: "neutrals.800",
		[CalendarItemState.OutOfRange]: "neutrals.40",
		[CalendarItemState.Selected]: "neutrals.0",
	};

	const fontWeights = {
		[CalendarItemState.Today]: "500",
		[CalendarItemState.Default]: "400",
		[CalendarItemState.OutOfRange]: "400",
		[CalendarItemState.Selected]: "500",
	};
	return (
		<Flex
			w="32px"
			h="32px"
			alignItems="center"
			justifyContent="center"
			border="1px solid"
			color={weekdayIndicator ? "neutrals.700" : fontColor[state]}
			borderColor={borderColors[state]}
			bgColor={backgroundColors[state]}
			borderRadius={borderRadius[state]}
			fontWeight={weekdayIndicator ? 500 : fontWeights[state]}
			onClick={() => onClick(value ?? new Date())}
			cursor={isSelectable ? "pointer" : "default"}
		>
			{label}
		</Flex>
	);
}
